module.exports = __webpack_public_path__ + "static/media/Noproject.8c8701eb.png";